import HttpError from './HttpError'

const baseUrl = process.env.REACT_APP_API_URL

export const login = (username, password) =>
  fetch(`${baseUrl}/api_2/login_check`, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ _username: username, _password: password }),
  }).then(res => {
    const json = res.json()
    if (res.ok) {
      return json.then(
        res => res,
        // console.log(res)
        // localStorage.setItem('id_token', res.token)
      )
    }
    return json.then((text, err) => Promise.reject(text))
  })



const defaultHeaders = {
  'Content-Type': 'application/json',
}

export const callApiWithParams = (
  endpoint,
  headers = {},
  method = 'GET',
  body = '',
) =>
  fetch(`${baseUrl}/api_2/${endpoint}`, {
    headers: {
      ...defaultHeaders,
      Authorization: localStorage.getItem('id_token')
        ? `Bearer ${localStorage.getItem('id_token')}`
        : undefined,
      ...headers,
    },
    method,
    body: method === 'PUT' || method === 'POST' ? body : undefined,
  })
    .then(response =>
      response.text().then(text => ({
        status: response.status,
        statusText: response.statusText,
        headers: response.headers,
        body: text,
      })),
    )
    .then(({ status, statusText, headers, body }) => {
      let json
      try {
        json = JSON.parse(body)
      } catch (e) {
        // not json, no big deal
      }
      if (status < 200 || status >= 300) {
        return Promise.reject(
          new HttpError((json && json.message) || statusText, status),
        )
      }
      // return { status, headers, body, json };
      return json
    })


export const fetchUserData = () => callApiWithParams('me')


export const getAthletes = () => {
    return callApiWithParams(`athletes`);
}
export const getPerformanceEvaluations = athleteId => {
    return callApiWithParams(`performance_evaluations?athleteDetails=${athleteId}&name=open123`);
}

export const savePerformanceData = (data, userid, token) => {
    const payload = {
        name: 'open123',
        data: JSON.stringify(data)
    }
    return fetch(`${baseUrl}/athletes/${userid}/performance-evaluations/open123`, {
        method: 'PUT',
        headers: {
            'Authorization': 'Bearer ' + (token || null),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
        .then(res => {
            if (!res.ok) {
                let json = res.json();
                return json.then((text, err) => {return Promise.reject(text);});
            }
        });
}



// WEBPACK FOOTER //
// ./src/lib/fetchService.js